export enum CardNetwork {
  visa = "visa",
  mastercard = "mastercard",
}
